import { type FloatingContext, useTransitionStyles } from '@floating-ui/react'

export const useFloatingTransition = (context: FloatingContext) => {
    return useTransitionStyles(context, {
        duration: 200,
        initial: {
            opacity: 0,
            transform: 'translateY(-10px)'
        },
        open: {
            opacity: 1,
            transform: 'translateY(0px)'
        },
        close: {
            opacity: 0,
            transform: 'translateY(-10px)'
        }
    })
}
